import React from 'react'

export default function InputIcon(props) {
    const svgHandler = (props) => {
        switch (props.icon) {
            case "email":
                return (
                    <g>
                        <path d="M0 0L20 0 20 20 0 20z" transform="translate(-1130 -387) translate(1130 387)" />
                        <path fill={props.color} d="M2.5 2.5h15c.46 0 .833.373.833.833v13.334c0 .46-.373.833-.833.833h-15c-.46 0-.833-.373-.833-.833V3.333c0-.46.373-.833.833-.833zm7.55 7.236L4.707 5.198l-1.08 1.27 6.434 5.463 6.317-5.467-1.09-1.26-5.237 4.532h-.001z" transform="translate(-1130 -387) translate(1130 387)" />
                    </g>
                )
            case "name":
                return (
                    <g fill="none" fillRule="evenodd">
                        <g transform="translate(-747 -452)">
                            <g>
                                <path d="M0 0L20 0 20 20 0 20z" transform="translate(747 452)" />
                                <path fill={props.color} d="M10 14.167c3.052 0 5.72 1.312 7.172 3.27l-1.535.726c-1.181-1.4-3.264-2.33-5.637-2.33-2.372 0-4.456.93-5.638 2.33l-1.534-.726c1.452-1.959 4.12-3.27 7.172-3.27zm0-12.5c2.301 0 4.167 1.865 4.167 4.166v2.5c0 2.302-1.866 4.167-4.167 4.167-2.301 0-4.167-1.865-4.167-4.167v-2.5c0-2.3 1.866-4.166 4.167-4.166z" transform="translate(747 452)" />
                            </g>
                        </g>
                    </g>
                )

            case "username":
                return (
                    <g transform="translate(-747 -452)">
                        <path d="M0 0L20 0 20 20 0 20z" transform="translate(747 452)" />
                        <path fill={props.color} d="M10 14.167c3.052 0 5.72 1.312 7.172 3.27l-1.535.726c-1.181-1.4-3.264-2.33-5.637-2.33-2.372 0-4.456.93-5.638 2.33l-1.534-.726c1.452-1.959 4.12-3.27 7.172-3.27zm0-12.5c2.301 0 4.167 1.865 4.167 4.166v2.5c0 2.302-1.866 4.167-4.167 4.167-2.301 0-4.167-1.865-4.167-4.167v-2.5c0-2.3 1.866-4.166 4.167-4.166z" transform="translate(747 452)" />
                    </g>
                )

            case "message":
                return (
                    <g stroke={props.color}>
                        <g>
                            <path d="M15.268 5.561l-4.266 3.434c-.806.633-1.94.633-2.746 0L3.954 5.561" opacity=".4" transform="translate(-1197 -498) translate(1120 288) translate(50 94) translate(28 117)" />
                            <path d="M4.888 0h9.428c1.36.015 2.653.59 3.58 1.59.928 1.003 1.407 2.34 1.326 3.704v6.528c.08 1.364-.398 2.701-1.326 3.704-.924.999-2.219 1.574-3.58 1.59H4.888C1.968 17.116 0 14.741 0 11.822V5.294C0 2.375 1.968 0 4.888 0z" transform="translate(-1197 -498) translate(1120 288) translate(50 94) translate(28 117)" />
                        </g>
                    </g>
                )

            case "calling":
                return (
                    <g>
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path fill={props.color} d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.901 13.901 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498z" />
                    </g>
                )

            case "text_area":
                return (
                    <g stroke={props.color}>
                        <path fill={props.color} d="M9.7 15.898L16.077 15.898" transform="translate(-1198 -687) translate(1120 288) translate(50 94) translate(29 306)" />
                        <path fill={props.color} d="M8.855.956c.737-.94 1.928-.89 2.868-.153l1.39 1.09c.94.737 1.273 1.88.536 2.82L5.359 15.29c-.277.354-.7.563-1.15.568l-3.196.04-.724-3.114c-.102-.437 0-.897.277-1.252L8.855.957V.956z" transform="translate(-1198 -687) translate(1120 288) translate(50 94) translate(29 306)" />
                        <path d="M7.303 2.936L12.097 6.694" transform="translate(-1198 -687) translate(1120 288) translate(50 94) translate(29 306)" />
                    </g>
                )

            default:
                return (
                    <g>
                        <path d="M0 0L20 0 20 20 0 20z" transform="translate(-1130 -465) translate(1130 465)" />
                        <path fill={props.color} d="M15 6.667h1.667c.46 0 .833.373.833.833v10c0 .46-.373.833-.833.833H3.333c-.46 0-.833-.373-.833-.833v-10c0-.46.373-.833.833-.833H5v-.834c0-2.761 2.239-5 5-5s5 2.239 5 5v.834zm-1.667 0v-.834c0-1.84-1.492-3.333-3.333-3.333-1.84 0-3.333 1.492-3.333 3.333v.834h6.666zm-4.166 5v1.666h1.666v-1.666H9.167zm-3.334 0v1.666H7.5v-1.666H5.833zm6.667 0v1.666h1.667v-1.666H12.5z" transform="translate(-1130 -465) translate(1130 465)" />
                    </g>
                )
        }
    }
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <g fill="none" >
                <g>
                    {
                        svgHandler(props)
                    }
                </g>
            </g>
        </svg>
    )
}


